(function () {
  if (window.__geGiftSync) return;
  window.__geGiftSync = true;

  var MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var PENDING_MS = 15000;
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var pendingUntil = 0;
  var busy = false;

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay || 700);
  }

  function onMutation() {
    pendingUntil = Date.now() + PENDING_MS;
    schedule(250);
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(window, arguments);
    if (MUTATION.test(url)) result.then(onMutation, function () {});
    return result;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (MUTATION.test(String(url))) this.addEventListener('loadend', onMutation);
    return xhrOpen.apply(this, arguments);
  };

  function signature(cart) {
    return cart.item_count + ':' + cart.total_price + ':' + cart.items.map(function (i) { return i.key + 'x' + i.quantity; }).join(',');
  }

  var kiteData = null;
  function campaigns() {
    if (!kiteData) {
      try {
        var el = document.getElementById('kite-app-data');
        kiteData = window.__geKiteData || window.kite_app_data || (el && el.textContent ? JSON.parse(el.textContent) : null);
      } catch (e) {
        kiteData = null;
      }
    }
    var data = kiteData;
    if (!data || !Array.isArray(data.freeGiftV2Campaigns)) return [];
    return data.freeGiftV2Campaigns.filter(function (c) { return c && c.isEnabled; });
  }

  function giftPending(cart) {
    var paid = cart.items.filter(function (i) { return !(i.properties && i.properties._free_product); });
    return campaigns().some(function (c) {
      try {
        var rule = c.segmentsData.segmentsList[0].buyXRulesData.rulesList[0];
        var ids = [];
        (rule.ruleValue.value || []).forEach(function (v) {
          if (v.productList) ids = ids.concat(v.productList.map(String));
          else if (v.productId) ids.push(String(v.productId));
        });
        var qty = paid.reduce(function (n, i) { return ids.indexOf(String(i.product_id)) > -1 ? n + i.quantity : n; }, 0);
        if (qty < (rule.ruleValue.qualifierValue || 1)) return false;
        return !cart.items.some(function (i) { return i.properties && i.properties._kite_promo_name === c.title; });
      } catch (e) {
        return false;
      }
    });
  }

  function renderPending(show) {
    var host = document.querySelector('#CartDrawer cart-drawer-items');
    var note = document.querySelector('.ge-gift-pending');
    if (show && host && !note) {
      note = document.createElement('div');
      note.className = 'ge-gift-pending';
      note.setAttribute('role', 'status');
      note.textContent = 'Adding your free gift…';
      host.parentNode.insertBefore(note, host);
    } else if (!show && note) {
      note.remove();
    }
  }

  function refreshCartPage(cart) {
    var items = document.getElementById('main-cart-items');
    if (!items) return;
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }
    var footer = document.getElementById('main-cart-footer');
    var ids = [items.dataset.id];
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    nativeFetch(window.location.pathname + '?sections=' + ids.join(',') + ',cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var pairs = [[items, sections[ids[0]]]];
        if (ids[1]) pairs.push([footer, sections[ids[1]]]);
        pairs.forEach(function (pair) {
          if (!pair[0] || !pair[1]) return;
          var doc = new DOMParser().parseFromString(pair[1], 'text/html');
          var fresh = doc.querySelectorAll('.js-contents');
          var current = pair[0].querySelectorAll('.js-contents');
          if (fresh.length !== current.length) {
            window.location.reload();
            return;
          }
          current.forEach(function (el, n) { el.innerHTML = fresh[n].innerHTML; });
        });
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () { window.location.reload(); });
  }

  function sync() {
    if (busy) return schedule(400);
    busy = true;
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sig = signature(cart);
        var stale = Array.prototype.some.call(document.querySelectorAll('[data-ge-cart-sig]'), function (el) {
          return el.getAttribute('data-ge-cart-sig') !== sig;
        });
        if (stale) {
          if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
          refreshCartPage(cart);
        }
        var waiting = Date.now() < pendingUntil && giftPending(cart);
        setTimeout(function () { renderPending(waiting); }, stale ? 600 : 0);
        if (waiting) schedule(1500);
        else pendingUntil = 0;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
})();

(function () {
  if (window.__geCartSearch) return;
  window.__geCartSearch = true;

  function go(box) {
    var input = box.querySelector('input[type="search"]');
    var q = input ? input.value.trim() : '';
    if (!q) { if (input) input.focus(); return; }
    window.location.href = box.getAttribute('data-ge-search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ge-search-go]');
    if (!btn) return;
    e.preventDefault();
    go(btn.closest('[data-ge-search]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var box = e.target.closest('[data-ge-search]');
    if (!box) return;
    e.preventDefault();
    go(box);
  });
})();

(function () {
  if (window.__geBundleTidy) return;
  window.__geBundleTidy = true;

  // A bundle item left alone in the cart (the other item was removed) drops its bundle tags, so its
  // order and subscription read as a normal single product instead of "bundle". Plan and price stay.
  var TAGS = ['_bundle', '_appstle-bb-id', '__appstle-bb-name', '_appstle_bundles_type', '_appstle-bundles-variants'];
  var CHANGED = /\/cart\/(change|update)(\.js)?(\?|$)/;
  var OWN = 'ge=bundle-tidy';
  var timer = null;
  var busy = false;

  var wrapped = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = wrapped.apply(this, arguments);
    if (CHANGED.test(url) && url.indexOf(OWN) === -1) result.then(later, function () {});
    return result;
  };

  function later() {
    clearTimeout(timer);
    timer = setTimeout(tidy, 400);
  }

  function planOf(line) {
    return line.selling_plan_allocation ? line.selling_plan_allocation.selling_plan.id : null;
  }

  function lone(cart) {
    var groups = {};
    cart.items.forEach(function (line) {
      var name = line.properties && line.properties._bundle;
      if (!name) return;
      var k = name + '|' + (planOf(line) || 'once');
      (groups[k] = groups[k] || []).push(line);
    });
    return Object.keys(groups).filter(function (k) { return groups[k].length === 1; }).map(function (k) { return groups[k][0]; });
  }

  function post(url, body) {
    return window.fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + OWN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r;
    });
  }

  // Shopify can't delete a line's tags in place, so the untagged copy goes in first (same variant,
  // plan and quantity, so any free gift stays attached), then the tagged line comes out. If the copy
  // can't be added first (e.g. low stock), the tagged line comes out first instead.
  function untag(line) {
    var props = {};
    Object.keys(line.properties || {}).forEach(function (k) {
      var v = line.properties[k];
      if (TAGS.indexOf(k) === -1 && v !== '' && v != null) props[k] = v;
    });
    var item = { id: line.variant_id, quantity: line.quantity, properties: props };
    if (planOf(line)) item.selling_plan = planOf(line);
    var remove = function () { return post('/cart/change.js', { id: line.key, quantity: 0 }); };
    var add = function () { return post('/cart/add.js', { items: [item] }); };
    return add().then(remove, function () { return remove().then(add); });
  }

  function tidy() {
    if (busy) return later();
    busy = true;
    window.fetch('/cart.js?' + OWN, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return lone(cart).reduce(function (chain, line) {
          return chain.then(function () { return untag(line); });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  if (window.__geBundleLone) tidy();
})();
